(() => {
  "use strict";
 
  const TOOLBAR_SELECTOR = "[data-engraving-toolbar]";
  const BUTTON_SELECTOR = "[data-engraving-symbol]";
  const FIELD_SELECTOR =
    'input.po-textField-input[type="text"], textarea.po-textField-input';
 
  /**
   * Findet das erste Easify-Textfeld, das im Dokument
   * direkt nach der jeweiligen Symbolleiste erscheint.
   */
  function findTargetField(toolbar) {
    const fields = Array.from(document.querySelectorAll(FIELD_SELECTOR));
 
    return (
      fields.find((field) => {
        const position = toolbar.compareDocumentPosition(field);
 
        return Boolean(position & Node.DOCUMENT_POSITION_FOLLOWING);
      }) || null
    );
  }
 
  /**
   * Verknüpft die Symbolleiste mit dem nachfolgenden Easify-Textfeld.
   */
  function initializeToolbar(toolbar) {
    const targetId = toolbar.dataset.engravingTarget;
 
    if (!targetId) {
      return null;
    }
 
    const field =
      document.getElementById(targetId) || findTargetField(toolbar);
 
    if (!field) {
      return null;
    }
 
    // Behebt die Entwicklerwarnung wegen der fehlenden ID.
    field.id = targetId;
 
    // Gibt dem Feld zusätzlich einen zugänglichen Namen.
    if (!field.hasAttribute("aria-label")) {
      field.setAttribute("aria-label", "Gravurtext Damenring");
    }
 
    /*
     * Easify erzeugt aktuell max="30".
     * Bei Textfeldern ist jedoch maxlength="30" die korrekte
     * HTML-Eigenschaft zur Zeichenbegrenzung.
     */
    const maximumLength = field.getAttribute("max");
 
    if (maximumLength && !field.hasAttribute("maxlength")) {
      field.setAttribute("maxlength", maximumLength);
    }
 
    return field;
  }
 
  /**
   * Initialisiert alle vorhandenen Symbolleisten.
   */
  function initializeAllToolbars() {
    document
      .querySelectorAll(TOOLBAR_SELECTOR)
      .forEach(initializeToolbar);
  }
 
  /**
   * Setzt den Wert über den nativen Browser-Setter.
   * Das funktioniert zuverlässiger bei appgesteuerten Feldern.
   */
  function setNativeValue(field, value) {
    const prototype =
      field instanceof HTMLTextAreaElement
        ? HTMLTextAreaElement.prototype
        : HTMLInputElement.prototype;
 
    const descriptor = Object.getOwnPropertyDescriptor(
      prototype,
      "value"
    );
 
    if (descriptor?.set) {
      descriptor.set.call(field, value);
    } else {
      field.value = value;
    }
  }
 
  document.addEventListener("click", (event) => {
    const button = event.target.closest(BUTTON_SELECTOR);
 
    if (!button) {
      return;
    }
 
    const toolbar = button.closest(TOOLBAR_SELECTOR);
 
    if (!toolbar) {
      return;
    }
 
    event.preventDefault();
 
    const field = initializeToolbar(toolbar);
 
    if (!field) {
      console.warn(
        "Das zugehörige Easify-Gravurtextfeld wurde nicht gefunden."
      );
      return;
    }
 
    const symbol = button.dataset.engravingSymbol || "";
    const currentValue = field.value || "";
 
    const selectionStart =
      typeof field.selectionStart === "number"
        ? field.selectionStart
        : currentValue.length;
 
    const selectionEnd =
      typeof field.selectionEnd === "number"
        ? field.selectionEnd
        : selectionStart;
 
    const newValue =
      currentValue.slice(0, selectionStart) +
      symbol +
      currentValue.slice(selectionEnd);
 
    const maximumLength = Number.parseInt(
      field.getAttribute("maxlength") || "",
      10
    );
 
    if (
      Number.isFinite(maximumLength) &&
      newValue.length > maximumLength
    ) {
      field.focus();
      return;
    }
 
    setNativeValue(field, newValue);
 
    // Easify über die Änderung informieren.
    field.dispatchEvent(new Event("input", { bubbles: true }));
    field.dispatchEvent(new Event("change", { bubbles: true }));
 
    const newCursorPosition = selectionStart + symbol.length;
 
    field.focus();
    field.setSelectionRange(
      newCursorPosition,
      newCursorPosition
    );
  });
 
  /*
   * Easify rendert seine Felder beim Variantenwechsel eventuell neu.
   * Deshalb initialisieren wir sie bei DOM-Änderungen erneut.
   */
  const observer = new MutationObserver(() => {
    initializeAllToolbars();
  });
 
  document.addEventListener("DOMContentLoaded", () => {
    initializeAllToolbars();
 
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})()